export default function getUserPreferencesURL() {
  return '/insightweb/userProfile#userPref'
}
